import { useEffect, useState } from 'react';
import Styles from './Clock.module.scss';
import classnames from "classnames"
const Clock = () => {

    const [time, setTime] = useState(new Date());

    useEffect(() => {
        setInterval(() => {
            setTime(new Date())
        }, 1000);
    }, []);

    const numberOfHourMarking = 12;
    const numberOfMinuteMarking = 12;

    // Using Array.from to create an array with numbers from 1 to numberCount
    const hours = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2] // Array.from({ length: numberOfHourMarking }, (_, index) => index + 1);
    const minutes = Array.from({ length: numberOfMinuteMarking }, (_, index) => index + 1);

    return (
        <div className={Styles.container}>
            <div className={Styles.clock}>
                <div className={Styles.watch_face} />
            <div id="hour" className={Styles.hour} style={{ transform: `rotate(${time.getHours() * 30 + time.getMinutes() / 2}deg)` }}></div>
            <div id="minute" className={Styles.minute} style={{ transform: `rotate(${time.getMinutes() * 6}deg)` }}></div>
            <div id="second" className={Styles.second} style={{ transform: `rotate(${time.getSeconds() * 6}deg)` }}></div>
            <div className={Styles.center}></div>
            </div>


        </div>

    )
}

export default Clock
